import { Button, Input, Typography } from '@breetometer/components';
import { openIntercom } from 'BreetHelpers';
import { selectUser, useAppSelector } from 'BreetRedux';

import type { IRecoveryCodeFormProps } from './RecoveryCodeForm.helpers';

const RecoveryCodeForm = ({
	errorMessage,
	handleRecoveryCodeValue,
	submitRecoveryCode,
	btnDisabled,
	isLoading,
	disableRecoveryCode,
	recoveryCodeValue,
}: IRecoveryCodeFormProps) => {
	const userData = useAppSelector(selectUser);

	const endMsg = userData.data?.data ? `Here is my User ID: \n\n${userData.data.data._id}` : 'Please help!';

	const intercomMsg = `Hi Breet, I've used up all my backup codes for my account. \n\n${endMsg}`;

	return (
		<div className='new-recovery-code'>
			<Typography
				as='h5'
				className='color-neutral-50'
			>
				Enter Backup Code
			</Typography>

			<Typography className='color-primary-100'>Enter one of your single-use backup codes to verify your identity.</Typography>

			<Input
				label='Backup Code'
				id='recovery-code'
				widthType='full'
				onChange={handleRecoveryCodeValue}
				errorMessage={errorMessage}
				value={recoveryCodeValue}
				required
			/>

			<div className='backup-alternative'>
				<Button
					variant='native'
					className='color-tertiary-400'
					onClick={disableRecoveryCode}
				>
					Use Authenticator App
				</Button>
			</div>

			<Button
				variant='primary'
				onClick={submitRecoveryCode}
				isLoading={isLoading}
				disabled={btnDisabled}
			>
				Continue
			</Button>

			<div className='support-alternative'>
				<Typography className='color-primary-100'>Having troubles using recovery code?</Typography>
				<Button
					variant='native'
					className='color-tertiary-400'
					onClick={openIntercom(intercomMsg)}
				>
					Contact Support
				</Button>
			</div>
		</div>
	);
};

export default RecoveryCodeForm;
